// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1024":"1b819dad","1054":"14d1a6eb","2128":"d29a7a6b","2161":"d29a7a6b","2851":"f04385b1","4072":"1b819dad","6304":"0bf48d57","9559":"1b819dad"}[chunkId] + ".chunk.css";
};